import LocationSelector from './LocationSelector'
export default LocationSelector
